var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('jps-list',{attrs:{"title":_vm.title,"subtitle":_vm.title,"crumbs":_vm.crumbs,"url":_vm.url,"fields":_vm.fields,"model":_vm.model,"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }